import { TotalSupplyAbi } from '../abis/shared'
import type { LstRegistryEntry } from '../registry'
import { ONE_E18, rescaleDecimals, toBigInt, type LstReader } from './shared'

/**
 * Off-chain reader — single `totalSupply()` so the entry carries
 * non-zero state even when no rate getter is available on-chain.
 *
 * Used when an LST publishes its exchange rate exclusively off-chain
 * and the rest of the on-chain surface is the bare ERC-20. The value
 * rate is a flat 1:1 (`exchangeRate = 1e18`), but `totalAssets` is in
 * the *underlying* asset's decimals — so when share ≠ underlying
 * decimals (e.g. 18-dec SolvBTC over 8-dec WBTC) the share-denominated
 * supply is rescaled to the underlying.
 */
export const readerOffChain = (entry: LstRegistryEntry): LstReader => {
  const shareDec = entry.decimals
  const underlyingDec = entry.underlyingDecimals ?? entry.decimals
  return {
    calls: [{ address: entry.address, name: 'totalSupply', params: [] }],
    abis: [TotalSupplyAbi],
    parse: ([supply]) => {
      const totalSupply = toBigInt(supply)
      if (totalSupply === undefined) return undefined
      return {
        totalAssets: rescaleDecimals(totalSupply, shareDec, underlyingDec),
        totalSupply,
        exchangeRate: ONE_E18,
      }
    },
  }
}
